import React, { useState } from "react";
import { usePacotes } from "../../services";
import { Pacote } from "../../types";
import { CModal } from "../data-display";
import { FormPacotes } from "./form-pacotes.component";

import AddIcon from "@mui/icons-material/Add";
import { IconButton } from "@mui/material";
import { getDownloadURL, ref, uploadBytesResumable } from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import { storage } from "../../lib/cliente";
import { memoObserver } from "../../utils/memoObserver.utils";
import { FormPacoteRef } from "./form-pacotes.component";

export const ModalFormPacotes = memoObserver(() => {
  const { addPacote } = usePacotes();
  const formRef = React.useRef<FormPacoteRef>(null);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const onSubmit = async (values: Pacote) => {
    try {
      const files = formRef?.current?.getFiles();
      setLoading(true);
      if (files) {
        const uploadPromises: Promise<string>[] = files.map(
          async (file: any | Blob) => {
            return new Promise<string>((resolve, reject) => {
              if (!file.status) {
                const uniqueFileName = uuidv4() + "-" + file.name;
                const fileRef = ref(storage, `images/${uniqueFileName}`);
                const uploadTask = uploadBytesResumable(fileRef, file);
                uploadTask.on(
                  "state_changed",
                  null,
                  (error) => reject(error),
                  async () => {
                    try {
                      const url = await getDownloadURL(uploadTask.snapshot.ref);
                      resolve(url);
                    } catch (error) {
                      reject(error);
                    }
                  }
                );
              } else {
                resolve(file.url);
              }
            });
          }
        );
        const resolvedUrls = await Promise.all(uploadPromises);

        const newItem = {
          ...values,
          imagesUrl: resolvedUrls,
        };

        await addPacote(newItem);
      }
    } catch (err) {
      console.log(err);
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <IconButton onClick={() => setOpen(true)}>
        <AddIcon />
      </IconButton>
      <CModal
        title="Novo Pacote"
        onSave={() => {
          formRef.current?.submit();
          handleClose();
        }}
        open={open}
        onClose={() => handleClose()}
        loading={loading}
      >
        <FormPacotes ref={formRef} onSubmit={onSubmit} />
      </CModal>
    </>
  );
});
